// extracted by mini-css-extract-plugin
export default {"root":"EventSettings_root__V6uvL","backButton":"EventSettings_backButton__fgFJG","menu":"EventSettings_menu__YtcYz"};